module.exports = __webpack_public_path__ + "static/media/establishmentid2.6a163409.svg";